import type { ColumnDef } from "../DataTable/types";
import type { NavSpec } from "../AppShell/types";

/** 對齊舊 admin/views/faq/_columns.php 的形狀，示範 8 種 formatter 全用到。 */
export interface DemoFaqRow {
  id: number;
  faqName: string;
  faqUrl: string;
  faqDetail: string;
  price: number;
  isPublished: boolean;
  createdAt: string;
  createdBy: string;
}

export const demoUsers: Record<string, string> = {
  u1: "王小明",
  u2: "林美玲",
};

export const demoFaqRows: DemoFaqRow[] = [
  {
    id: 1,
    faqName: "課程如何報名？",
    faqUrl: "/faq/how-to-register",
    faqDetail: "請至課程頁面點選「立即報名」，\n並完成付款程序。",
    price: 0,
    isPublished: true,
    createdAt: "2026-01-05T09:30:00+08:00",
    createdBy: "u1",
  },
  {
    id: 2,
    faqName: "退費規則為何？",
    faqUrl: "/faq/refund-policy",
    faqDetail: "開課前 7 天可全額退費，\n開課後不予退費。",
    price: 1500,
    isPublished: false,
    createdAt: "2026-02-14T14:00:00+08:00",
    createdBy: "u2",
  },
  {
    id: 3,
    faqName: "可以更改梯次嗎？",
    faqUrl: "/faq/change-batch",
    faqDetail: "同課程可申請一次免費改期。",
    price: 0,
    isPublished: true,
    createdAt: "2026-03-01T10:15:00+08:00",
    createdBy: "u1",
  },
];

export function buildDemoColumns(onEdit: (row: DemoFaqRow) => void, onDelete: (row: DemoFaqRow) => void): ColumnDef<DemoFaqRow>[] {
  return [
    { key: "serial", label: "#", kind: "serial", lockedVisible: true, width: "48px" },
    { key: "checkbox", label: "", kind: "checkbox", lockedVisible: true, width: "32px" },
    { key: "faqName", label: "問題", format: "text" },
    {
      key: "faqUrl",
      label: "網址",
      format: "raw",
      render: (row) => (
        <a href={row.faqUrl} target="_blank" rel="noreferrer">
          {row.faqUrl}
        </a>
      ),
    },
    { key: "faqDetail", label: "詳細說明", format: "ntext" },
    { key: "price", label: "費用", format: "currency" },
    {
      key: "isPublished",
      label: "狀態",
      format: "boolean",
      booleanLabels: ["停用", "啟用"],
      filterOptions: [
        { value: "是", label: "啟用" },
        { value: "否", label: "停用" },
      ],
    },
    { key: "createdAt", label: "建立時間", format: "datetime" },
    { key: "createdBy", label: "建立者", format: "user", userLabel: (id) => demoUsers[id] ?? id },
    {
      key: "actions",
      label: "操作",
      kind: "action",
      lockedVisible: true,
      actions: [
        { key: "edit", label: "編輯", onClick: onEdit, variant: "secondary" },
        { key: "delete", label: "刪除", onClick: onDelete, variant: "danger" },
      ],
    },
  ];
}

export const demoNav: NavSpec = [
  {
    key: "site",
    label: "網站管理",
    items: [
      { key: "faq", label: "常見問答", href: "/admin/faq" },
      { key: "news", label: "最新消息", href: "/admin/latest-news" },
      {
        key: "videos",
        label: "影音專區",
        children: [
          { key: "reels", label: "活動剪影", href: "/admin/video-reels" },
          { key: "training", label: "內訓影片", href: "/admin/training-videos" },
        ],
      },
    ],
  },
  {
    key: "config",
    label: "系統設定",
    items: [{ key: "roles", label: "權限管理", href: "/admin/role" }],
  },
];
